import React, { useRef, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import emailjs from "emailjs-com";

function ContactUs() {
  const form = useRef();

  // States for validation and sending
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isSending, setIsSending] = useState(false); // ✅ new state

  // Regular expressions for validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?\d{10,15}$/;

  // Validation handlers
  const validateEmail = (e) => {
    const email = e.target.value;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address (e.g. example@gmail.com)");
    } else {
      setEmailError("");
    }
  };

  const validatePhone = (e) => {
    const phone = e.target.value;
    if (!phoneRegex.test(phone)) {
      setPhoneError("Phone number should contain only digits (with optional +) and without spaces.");
    } else {
      setPhoneError("");
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const email = e.target.from_email.value;
    const phone = e.target.phone.value;

    // Validation before sending
    if (!emailRegex.test(email)) {
      alert("❌ Invalid email format!");
      return;
    }
    if (!phoneRegex.test(phone)) {
      alert("❌ Invalid phone number format!");
      return;
    }

    // ✅ Start sending state
    setIsSending(true);

    emailjs
      .sendForm(
        "service_4zv6p3h",
        "template_rhel5e4",
        form.current,
        "nv0npWKuleb6P0Hie"
      )
      .then(
        (result) => {
          console.log("✅ Email sent successfully!", result.text);
          alert("Message sent Successfully ✅");
          e.target.reset();
          setEmailError("");
          setPhoneError("");
        },
        (error) => {
          console.log("❌ Email send failed:", error.text);
          alert("Something went wrong ❌");
        }
      )
      .finally(() => {
        // ✅ End sending state
        setIsSending(false);
      });
  };

  return (
    <>
      <div className="md:pt-12 bg-[#FFFFFF] w-[100vw] flex flex-col">

        {/* Main section */}
        <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-10 px-6 py-10 md:px-16 lg:px-24 xl:px-40">
          
          {/* Left Section */}
          <div className="flex flex-col flex-1 gap-y-4 items-center md:items-start text-center md:text-left">
            <h1 className="text-[#494949] text-3xl sm:text-4xl md:text-5xl font-semibold">
              Contact Us
            </h1>

            <p className="text-[#494949] text-sm sm:text-base md:text-lg leading-relaxed">
              We are committed to processing the information in order to contact
              you and talk about your project.
            </p>

            {/* Email */}
            <div className="flex items-center gap-3 justify-center md:justify-start">
              <img src="email.png" alt="email" className="h-5 sm:h-6" />
              <span className="text-sm sm:text-base">
                mghaznavi1988@gmail.com
              </span>
            </div>

            {/* Address */}
            <div className="flex items-start gap-3 justify-center md:justify-start">
              <img
                src="mobile-chat.png"
                alt="address"
                className="h-5 sm:h-6 mt-1"
              />
              <span className="text-sm sm:text-base leading-tight">
                MM Coding Lingo Near Faysal bank <br /> I-8 Markaz, Islamabad
              </span>
            </div>

            {/* Phone */}
            <div className="flex items-center gap-3 justify-center md:justify-start">
              <img
                src="property-location.png"
                alt="phone"
                className="h-5 sm:h-6"
              />
              <span className="text-sm sm:text-base">+92 3003335666</span>
            </div>
          </div>

          {/* Right Section (Form) */}
          <div className="flex-1 flex justify-center w-full">
            <form
              ref={form}
              onSubmit={sendEmail}
              className="flex flex-col gap-4 w-full sm:w-[80%] md:w-[24vw]"
            >
              {/* Name */}
              <input
                className="pl-3 w-full h-[50px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#AC0E28]"
                placeholder="Name *"
                name="from_name"
                type="text"
                required
              />

              {/* Email */}
              <div className="flex flex-col">
                <input
                  className={`pl-3 w-full h-[50px] border ${
                    emailError ? "border-red-500" : "border-gray-300"
                  } rounded-md focus:outline-none focus:ring-2 focus:ring-[#AC0E28]`}
                  placeholder="Email *"
                  name="from_email"
                  type="email"
                  onChange={validateEmail}
                  required
                />
                {emailError && (
                  <span className="text-red-500 text-sm mt-1">{emailError}</span>
                )}
              </div>

              {/* Phone */}
              <div className="flex flex-col">
                <input
                  className={`pl-3 w-full h-[50px] border ${
                    phoneError ? "border-red-500" : "border-gray-300"
                  } rounded-md focus:outline-none focus:ring-2 focus:ring-[#AC0E28]`}
                  placeholder="Phone No *"
                  name="phone"
                  type="text"
                  onChange={validatePhone}
                  required
                />
                {phoneError && (
                  <span className="text-red-500 text-sm mt-1">{phoneError}</span>
                )}
              </div>

              {/* Message */}
              <textarea
                className="pl-3 pt-2 w-full h-[100px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#AC0E28]"
                placeholder="Message"
                name="message"
                required
              />

              {/* Button */}
              <button
                type="submit"
                disabled={isSending} // ✅ prevent multiple submissions
                className={`w-full h-[50px] rounded-md text-white font-semibold border transition duration-300 ease-in-out shadow-md active:scale-95 ${
                  isSending
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#AC0E28] hover:bg-white hover:text-[#AC0E28] hover:font-bold hover:border-[#AC0E28] hover:shadow-lg"
                }`}
              >
                {isSending ? "Sending..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
